// Laagstijlen die door meer dan één kaart gebruikt worden (CAMap en de
// workspace-kaart), zodat dezelfde soort data er overal hetzelfde uitziet.

import {
  CircleLayerSpecification,
  FillLayerSpecification,
  LineLayerSpecification,
} from "maplibre-gl";

export const circleSearchStyle: Partial<CircleLayerSpecification> = {
  paint: {
    "circle-radius": ["interpolate", ["linear"], ["zoom"], 4, 0.5, 14, 4],
    "circle-color": "rgba(255, 10, 10, 0.5)",
  },
};

// Alle perceelgrenzen uit de vector-tiles; dezelfde lijn als op de hoofdkaart.
export const parcelLineStyle: Partial<LineLayerSpecification> = {
  paint: {
    "line-color": "rgb(7, 119, 53)",
    "line-width": ["interpolate", ["linear"], ["zoom"], 10, 0.2, 18, 1.5],
  },
};

// De percelen die aan het actieve filter voldoen.
export const parcelMatchStyle: Partial<FillLayerSpecification> = {
  paint: {
    "fill-color": "rgba(255, 10, 10, 0.35)",
    "fill-outline-color": "rgb(200, 0, 0)",
  },
};

export const projectFillStyle: Partial<FillLayerSpecification> = {
  paint: {
    "fill-outline-color": [
      "coalesce",
      ["get", "tagOutline"],
      ["case", ["boolean", ["get", "selected"], false], "rgb(202, 138, 4)", "rgb(234, 179, 8)"],
    ],
    "fill-color": [
      "coalesce",
      ["get", "tagFill"],
      [
        "case",
        ["boolean", ["get", "selected"], false],
        "rgba(253, 224, 71, 0.5)",
        "rgba(253, 224, 71, 0.15)",
      ],
    ],
  },
};

export const projectStyle: Partial<LineLayerSpecification> = {
  paint: {
    "line-color": [
      "coalesce",
      ["get", "tagOutline"],
      ["case", ["boolean", ["get", "selected"], false], "rgb(146, 64, 14)", "rgb(202, 138, 4)"],
    ],
    "line-width": ["case", ["boolean", ["get", "selected"], false], 3, 2],
    "line-dasharray": [3, 2],
  },
};
